export default class Header {
	constructor() {
		this.header = document.querySelector('.l-header');
		this.scrollThreshold = 5;
		this.handleScroll = this.handleScroll.bind(this);

		this.accordionTriggers = document.querySelectorAll('.js-spAccordion-trigger');
		this.menuTrigger = document.querySelector('.js-spHeader-trigger');
		this.menuContents = document.querySelector('.js-spHeader-contents');

		if (this.header) {
			this.init();
		}
	}

	init() {
		this.handleScroll();
		window.addEventListener('scroll', this.handleScroll, { passive: true });

		this.initAccordion();
		this.initHamburger();
	}

	handleScroll() {
		const scrollY = window.scrollY || window.pageYOffset;
		if (scrollY >= this.scrollThreshold) {
			this.header.classList.add('is-fixed');
		} else {
			this.header.classList.remove('is-fixed');
		}
	}

	initAccordion() {
		this.accordionTriggers.forEach(trigger => {
			const content = trigger.nextElementSibling;
			if (!content || !content.classList.contains('js-spAccordion-contents')) return;

			// 初期設定
			content.style.height = '0';
			content.style.overflow = 'hidden';
			content.style.transition = 'height 0.3s ease';

			trigger.addEventListener('click', (e) => {
				// 767px以下のみ動作させる
				if (window.innerWidth > 767) return;

				e.preventDefault(); // リンク無効化

				const isOpen = trigger.classList.contains('is-active');

				if (isOpen) {
					trigger.classList.remove('is-active');
					content.style.height = content.scrollHeight + 'px'; // 一旦高さ設定
					requestAnimationFrame(() => {
						content.style.height = '0';
					});
				} else {
					trigger.classList.add('is-active');
					content.style.height = content.scrollHeight + 'px';
					// 一度 scrollHeight を明示的に適用してから auto
				}
			});

			// トランジション後、状態に応じて auto に
			content.addEventListener('transitionend', () => {
				if (trigger.classList.contains('is-active')) {
					content.style.height = 'auto';
				}
			});
		});
	}

	initHamburger() {
		if (!this.menuTrigger || !this.menuContents) return;

		this.menuTrigger.addEventListener('click', () => {
			this.menuContents.classList.toggle('is-menuOpen');
		});

		// ハンバーガーメニュー内のリンクをクリックした際にメニューを閉じる
		this.initHamburgerLinkClose();
	}

	initHamburgerLinkClose() {
		const menuLinks = this.menuContents.querySelectorAll('a');
		
		menuLinks.forEach(link => {
			link.addEventListener('click', () => {
				// 767px以下のみ動作させる（ハンバーガーメニューが表示される画面サイズ）
				if (window.innerWidth <= 767) {
					// アコーディオンのトリガーは除外（メニューを閉じない）
					if (link.classList.contains('js-spAccordion-trigger')) {
						return;
					}
					
					// 実際にページ遷移するリンクのみでメニューを閉じる
					this.menuContents.classList.remove('is-menuOpen');
				}
			});
		});
	}
}
